module.exports = __webpack_public_path__ + "media/images/smart_phone/login/202001/bnr_apr_title-00718689b789b50fefe676f25ef3c2d0.png";